export default "assets/images/icons/arrow-69d584db.svg";